import { ArrowBack, CancelScheduleSendOutlined, Clear, SaveAlt } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { I18nNamespace } from '~/common/types';
import { useIntakeRequestActions } from '~/hooks';
import { useChatSession } from '~/modules';
import { RouteId } from '~/routes/RouteId.ts';

import { PageAction } from './Actions.types.ts';

interface ActionProps {
  actions: PageAction[];
}

const MAPPED_ICONS = {
  [PageAction.DISCARD]: <Clear fontSize="small" />,
  [PageAction.SAVE_DRAFT]: <SaveAlt fontSize="small" />,
  [PageAction.CANCEL]: <CancelScheduleSendOutlined fontSize="small" />,
  [PageAction.RETURN_TO_LIST]: <ArrowBack fontSize="small" />,
};

export const Actions = ({ actions }: ActionProps) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeDetail.action' });
  const session = useChatSession();
  const { discard, cancel } = useIntakeRequestActions();

  const navigate = useNavigate();
  const handleNavigationToList = () => {
    navigate(RouteId.intake);
  };

  const MAPPED_CALLBACKS: Record<PageAction, () => void> = {
    [PageAction.DISCARD]: async () => {
      discard(session.id, handleNavigationToList);
    },
    [PageAction.CANCEL]: async () => {
      cancel(session.id, handleNavigationToList);
    },
    [PageAction.SAVE_DRAFT]: handleNavigationToList,
    [PageAction.RETURN_TO_LIST]: handleNavigationToList,
  };

  return (
    <>
      {actions.map((action) => (
        <MenuItem
          key={action}
          onClick={MAPPED_CALLBACKS[action]}
          data-intercom-target={`IntakeDetail/Actions/${action}`}
        >
          <ListItemIcon>{MAPPED_ICONS[action]}</ListItemIcon>
          <ListItemText primary={t(action)} />
        </MenuItem>
      ))}
    </>
  );
};
